exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.basic-user-card{display:flex;flex:1 0;margin:0;padding:.6em 1em\n}\n.basic-user-card-collapsed-content{margin-left:.7em;text-align:left;flex:1;min-width:0\n}\n.basic-user-card-user-name img{-o-object-fit:contain;object-fit:contain;height:16px;width:16px;vertical-align:middle\n}\n.basic-user-card-user-name-value,.basic-user-card-screen-name{display:inline-block;max-width:100%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis\n}\n.basic-user-card-expanded-content{flex:1;margin-left:.7em;min-width:0\n}", ""]);

// exports
